// extracted by mini-css-extract-plugin
module.exports = {"serviceCard":"serviceCard--2MxaV","serviceImg":"serviceImg--2Uzx2","serviceTitle":"serviceTitle--1Cxa9","serviceDescription":"serviceDescription--Q9Cqf"};